import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import {
  CmsState,
  CmsAction,
  CmsActionTypes
} from './types'

export const initialState: CmsState = {
  isFetchingCreate: false,
  isFetching: false,
  // @ts-ignore
  pdf: undefined,
  error: false,
}

// @ts-ignore
export const cmsReducer: Reducer<CmsState> = createReducer<
  CmsState,
  CmsAction
>(initialState, {
  [CmsActionTypes.GET_CMS_PDF_REQUEST]: (state: CmsState) => ({
    ...state,
    isFetching: true
  }),
  [CmsActionTypes.GET_CMS_PDF_SUCCESS]: (
    state: CmsState,
    action: CmsAction
  ) => ({
    ...state,
    isFetching: false,
    // @ts-ignore
  }),
  [CmsActionTypes.GET_CMS_PDF_FAIL]: (state: CmsState) => ({
    ...state,
    isFetching: false
  })
})
